const BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'ummahti-backend.firebasestorage.app';
export const templatePreviewUrl = (preview) =>
  `https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o/${encodeURIComponent(`template_previews/${preview}`)}?alt=media`;
